import { api } from "../client";
import { Config, ConfigMutate } from "../types";
import {
  AccountUserExtraFields,
  AccountUserFields,
  PartialCommissionExtraFields,
  PartialCommissionFields,
} from "../schema";

type ApiRequestConfig = Config<AccountUserFields, AccountUserExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialCommissionFields,
  PartialCommissionExtraFields
>;

export const getAccountUsers = (config?: ApiRequestConfig) => {
  return api.get<AccountUserFields, AccountUserExtraFields>(
    `account_users`,
    config
  );
};

export const getAccountUser = (id: number, config?: ApiRequestConfig) => {
  return api.get<AccountUserFields, AccountUserExtraFields>(
    `account_users/${id}`,
    config
  );
};

export const createAccountUser = (config?: ApiRequestConfigMutate) => {
  return api.create<AccountUserFields, AccountUserExtraFields>(
    `account_users`,
    config
  );
};

export const updateAccountUser = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<AccountUserFields, AccountUserExtraFields>(
    `account_users/${id}`,
    config
  );
};

export const deleteAccountUser = (id: number) => {
  return api.remove<AccountUserFields, AccountUserExtraFields>(
    `account_users/${id}`
  );
};
